import { useDecision } from '@optimizely/react-sdk';

import { FeatureFlags, WorkflowUxVariables } from '@frontend/constants/featureFlags';
import { useFeatureFlag } from '@frontend/feature-flags';

export function useWorkflowUx() {
  const [decision] = useDecision(FeatureFlags.WORKFLOW_UX);
  const vars = decision?.variables;
  const { enabled: codeStepEnabled } = useFeatureFlag(FeatureFlags.CODE_STEP_ENABLED);

  return {
    naturalLanguageConditions: Boolean(vars?.[WorkflowUxVariables.NATURAL_LANGUAGE_CONDITIONS]),
    staticParameters: Boolean(vars?.[WorkflowUxVariables.STATIC_PARAMETERS]),
    workflowNesting: Boolean(vars?.[WorkflowUxVariables.WORKFLOW_NESTING]),
    workflowBuilderUxV2: Boolean(vars?.[WorkflowUxVariables.WORKFLOW_BUILDER_UX_V2]),
    workflowGlobalSearch: Boolean(vars?.[WorkflowUxVariables.WORKFLOW_GLOBAL_SEARCH]),
    capacityBanner: Boolean(vars?.[WorkflowUxVariables.CAPACITY_BANNER]),
    workflowPriorityOptionInTrigger: Boolean(
      vars?.[WorkflowUxVariables.WORKFLOW_PRIORITY_OPTION_IN_TRIGGER]
    ),
    hitlNode: Boolean(vars?.[WorkflowUxVariables.HITL_NODE]),
    codeStepEnabled,
    firstClassConditionNode: Boolean(vars?.[WorkflowUxVariables.FIRST_CLASS_CONDITION_NODE]),
    spotlight: Boolean(vars?.[WorkflowUxVariables.SPOTLIGHT]),
  };
}
